import React from "react";
import { Row, Col } from "react-bootstrap";

import bubbleIllustration from "../../../../img/bubble-illustration.png";
import firstVideo from "../../../../img/first_introduction.mp4";
import secondVideo from "../../../../img/second_introduction.mp4";
import thirdVideo from "../../../../img/third_introduction.mp4";

import "./style.scss";

const Index = () => {
  return (
    <section className="frontpage-pitch-section">
      <div className="inner-frontpage-pitch-container">
        <div className="content-container">
          <Row className="section-row">
            <Col
              md={{ span: 6, order: 1 }}
              className="illustration-col my-auto"
            >
              <Col className="inner-illustration-col">
                <img
                  alt="Prospecting illustrasjon"
                  className="section-illustration"
                  src={bubbleIllustration}
                />
                <div className="video-container">
                  <video
                    className="video-player"
                    width="100%"
                    height="100%"
                    controls={false}
                    muted={true}
                    autoPlay={true}
                    loop={true}
                    playsInline={true}
                  >
                    <source src={firstVideo} type="video/mp4" />
                  </video>
                </div>
              </Col>
            </Col>
            <Col md={{ span: 6, order: 2 }} className="content-col my-auto">
              <Col className="inner-content-col">
                <p className="short-section-description">
                  Prospecting gjort på den riktige måten
                </p>
                <h3 className="section-title">
                  Gjør kvalifiseringen av prospekter på forhånd og øk dine
                  muligheter for salg umiddelbart.
                </h3>
                <p className="section-description">
                  Med Leadfind kan du segmentere og generere lister på opp til
                  10 000 foretak basert på bransje, næringskode, lokasjon og
                  økonomi. På denne måten kan du sørge for at du kun når ut til
                  personer det faktisk er hensiktsmessig og ønskelig å selge
                  til.
                </p>
              </Col>
            </Col>
          </Row>
          <Row className="section-row">
            <Col
              xs={{ span: 12, order: 2 }}
              sm={{ span: 12, order: 2 }}
              lg={{ span: 6, order: 1 }}
              className="content-col my-auto"
            >
              <Col className="inner-content-col">
                <p className="short-section-description">
                  Alle kunderelasjonene dine på ett sted
                </p>
                <h3 className="section-title">
                  Få oversikt over alle forholdene til virksomheten din, av både
                  bedrifts- og personkunder.
                </h3>
                <p className="section-description">
                  Du kan enkelt legge til et nytt kundeforhold, og velge om du
                  vil fylle inn informasjonen manuelt eller ved å oppgi et
                  organisasjonsnummer. Leadfind vil på bare noen få sekunder
                  hente resten av informasjonen automatisk, som sparer deg for
                  unødvendig ekstraarbeid.
                </p>
              </Col>
            </Col>
            <Col
              xs={{ span: 12, order: 1 }}
              sm={{ span: 12, order: 1 }}
              md={{ span: 6, order: 1 }}
              lg={{ span: 6, order: 2 }}
              className="illustration-col my-auto"
            >
              <Col className="inner-illustration-col">
                <img
                  alt="CRM illustrasjon"
                  className="section-illustration"
                  src={bubbleIllustration}
                />
                <div className="video-container">
                  <video
                    className="video-player"
                    width="100%"
                    height="100%"
                    controls={false}
                    muted={true}
                    autoPlay={true}
                    loop={true}
                    playsInline={true}
                  >
                    <source src={secondVideo} type="video/mp4" />
                  </video>
                </div>
              </Col>
            </Col>
          </Row>
          <Row className="section-row">
            <Col
              md={{ span: 6, order: 1 }}
              className="illustration-col my-auto"
            >
              <Col className="inner-illustration-col">
                <img
                  alt="Pipeline illustrasjon"
                  className="section-illustration"
                  src={bubbleIllustration}
                />
                <div className="video-container">
                  <video
                    className="video-player"
                    width="100%"
                    height="100%"
                    controls={false}
                    muted={true}
                    autoPlay={true}
                    loop={true}
                    playsInline={true}
                  >
                    <source src={thirdVideo} type="video/mp4" />
                  </video>
                </div>
              </Col>
            </Col>
            <Col md={{ span: 6, order: 2 }} className="content-col my-auto">
              <Col className="inner-content-col">
                <p className="short-section-description">
                  Kontroller alle salgstrakter
                </p>
                <h3 className="section-title">
                  Skaff deg et bedre overblikk over alle interaksjoner bedriften
                  din gjør.
                </h3>
                <p className="section-description">
                  Gjennom pipelines kan du bygge dine egne salgstrakter og holde
                  oversikt over hvor du befinner deg i ulike salgsprosessene.
                  Gjennom drag-and-drop funksjonalitet kan du enkelt flytte
                  leads slik du måtte ønske, så du lettere ser hvor nærme du er
                  en avtale.
                </p>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default Index;
